import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfigurationsStore } from 'src/store/configurations/configurations.store';

export const useConfigurations = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { loadingPage, loadingUpdate, configList, getAll, update } = useConfigurationsStore();
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  useEffect(() => {
    getAll();
  }, []);

  useEffect(() => {
    setStartDate(new Date(configList[0]?.value?.startDate));
    setEndDate(new Date(configList[0]?.value?.endDate));
  }, [configList]);

  const handleUpdate = async (name: string, value: any) => {
    await update(name, value)
      .then(() => {
        enqueueSnackbar('Configuração atualizada com sucesso!');
        getAll();
      })
      .catch((e) => {
        enqueueSnackbar('Erro ao atualizar configuração!', { variant: 'error' });
      });
  };

  return {
    loadingPage,
    loadingUpdate,
    configList,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    navigate,
    handleUpdate,
  };
};
